import { render, staticRenderFns } from "./Motives.vue?vue&type=template&id=0fdfdda2&"
import script from "./Motives.vue?vue&type=script&lang=js&"
export * from "./Motives.vue?vue&type=script&lang=js&"
import style0 from "./Motives.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports